<template>
  <div>
    <div class="mb-3" v-for="(msg, id) in ocorrenciaReturn" :key="id">
      <v-mensagem :mensagem="msg" :perfil="perfil" :tipoReembolso="ocorrencia.tipo_reembolso"></v-mensagem>
    </div>
    <b-row class="mt-3 mb-3" align-self="right" v-if="ocorrencia.id">
      <b-button
        v-if="['adm', 'coord_comercial'].includes(perfil) && ['SOLUCIONADO', 'FECHADO'].includes(ocorrencia.status)"
        size="sm"
        variant="warning"
        @click="reabrirOc"
        class="mr-3"
        :disabled="loading"
      >
        <i class="fas fa-undo"></i>
        Reabrir Ocorrência
      </b-button>

      <b-button 
        size="sm" 
        variant="danger" 
        @click="cancelar()" 
        :disabled="loading"
        v-if="['adm', 'coord_comercial', 'sac'].includes(perfil) && ['FECHADO', 'CANCELADA'].includes(ocorrencia.status)"
      >
        <i class="fas fa-ban"></i>
        Cancelar Ocorrência
      </b-button>
    </b-row>

    <b-card 
      v-if="
        ocorrencia.status != 'NOVO' &&
        ['adm', 'coord_comercial', 'comercial'].includes(perfil) &&
        ocorrencia.notificacoes &&
        ocorrencia.notificacoes.length > 0
      "
      class="mb-3"
    >
      <div>
        <h6>Notificações</h6>
      </div>
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1" v-for="(notificacao, id) in ocorrencia.notificacoes" :key="id">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block @click="notificacao.visible = !notificacao.visible" size="sm" variant="secondary">{{
              notificacao.destinatario }}</b-button>
          </b-card-header>
          <b-collapse visible v-model="notificacao.visible" role="tabpanel">
            <b-card-body>
              <b-card-text>
                <b-row> Enviado por: {{ notificacao.user.name }} </b-row>
                <b-row class="mt-2"> Cc: {{ notificacao.cc }} </b-row>
                <b-row class="mt-2">
                  Mensagem: {{ notificacao.mensagem }}
                </b-row>
                <b-row class="mt-2">
                  <b-col>
                    {{ formatarData(mensagem.created_at) }}
                  </b-col>
                  <b-col>
                    Enviado Anexos: {{ notificacao.anexo ? "Sim" : "Não" }}
                  </b-col>
                </b-row>
              </b-card-text>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </b-card>

    <b-card v-if="viewCardMensagem" :class="tipoMsg">
      <b-overlay :show="loading" rounded="sm">
        <b-form-group small label-size="sm" id="formulario">
          <b-row v-if="!ocorrencia.id">
            <b-col cols="6">
              <label for="tipoO">Tipo de Ocorrência</label>
              <b-form-select :disabled="ocorrencia.id > 0" id="tipoO" v-model="tipoOcorrencia" :options="optionsOc"
                @change="produtoClear" size="sm"></b-form-select>
            </b-col>
            <b-col v-if="classeDistribuidor === 'G'">
              <label for="">Enviar Para:</label>
              <b-form-select size="sm" v-model="enviarPara" :options="optionsEnviarPara" />
            </b-col>
          </b-row>

          <b-row v-if="!ocorrencia.id" class="mt-3">
            <b-col>
              <label for="">Lote</label>
              <b-form-select id="tipoO" v-model="lote" :options="optionsLote" @change="produtoClear"
                size="sm"></b-form-select>
            </b-col>           
            <b-col cols="6">
              <div v-if="revendedoras.length > 0">
                <label for="">Revendedora</label>
                <b-form-select size="sm" v-model="revendedora" :options="revendedoras" />
              </div>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col cols="12" class="text-right"
              v-if="!ocorrencia.id && tipoOcorrencia && (tipoOcorrencia < 4 || tipoOcorrencia == 6) && produtosPedido.length > 0">
              <b-button size="sm" variant="primary" @click="modalProdutos = true">
                <i class="fas fa-edit"></i> Editar Produtos
              </b-button>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="text-right mr-3">
              <small v-if="produto && produto.quantidade" style="color:red">Quantidade máxima: {{ produto.quantidade
                }}</small>
            </b-col>
          </b-row>

          <b-row v-if="!ocorrencia.id && tipoOcorrencia && (tipoOcorrencia < 4 || tipoOcorrencia == 6)" class="mt-3">
            <b-col v-if="getProdutosIncluidos.length > 0">
              <label class="d-flex align-items-center mb-1">
                <span>Lote do Produto com Avaria (por produto)</span>
               <i class="fas fa-info-circle text-info ml-2" v-b-tooltip.hover
                  title="Informe o lote de avaria para cada produto(somente numeros). Se houver múltiplos lotes para o mesmo produto, informe na descrição da ocorrencia, separe com vírgula (Ex:codigo: 2222  lote: 888888, 999999, 123456)"
                ></i>
              </label>
              <b-table :items="getProdutosIncluidos" :fields="colunas">
                <template #cell(label)="row">
                  <small>
                    {{ row.item.codigo + ' - ' + row.item.nome }}
                  </small>
                </template>
                <template #cell(lote_produto_avaria)="row">
                  <b-form-input
                    v-model="row.item.lote_produto_avaria"
                    type="text"
                    placeholder="Ex: 999999"
                    size="sm"
                    @input="row.item.lote_produto_avaria = row.item.lote_produto_avaria.replace(/[^0-9]/g, '')"
                    @change="row.item.lote_produto_avaria = row.item.lote_produto_avaria ? String(row.item.lote_produto_avaria).trim() : ''"

                  ></b-form-input>
                </template>
              </b-table>
            </b-col>
          </b-row>

          <b-row class="mt-3 mb-1" v-if="ocorrencia.id || ocorrencia.status == 'SOLUCIONADO'" align-v="end">
            <b-col v-if="ocorrencia.id && ocorrencia.status != 'REABRIR'" class="col-md-6">
              <label for="">Tipo de Mensagem</label>
              <b-form-select v-model="tipoMsg" :options="optionsMsg" size="sm" :disabled="loading" />
            </b-col>
            <b-col v-if="showAprovaReembolso" class="col-md-6">
              <label for="">Aprovar Reembolso?</label>
              <b-form-select v-model="reembolso" :options="reembolsoOptions" size="sm" :disabled="loading" />
            </b-col>
            <b-col v-if="tipoMsg == 'SOLUCIONAR' && (ocorrencia.tipo < 4 || ocorrencia.tipo == 6)">
              <label for="">Tipo de Reembolso</label>
              <b-form-select v-model="tipoReembolso" :options="optionsReembolso" size="sm" :disabled="loading" />
            </b-col>
          </b-row>

          <div v-if="tipoMsg == 'SOLUCIONAR' && tipoReembolso && tipoReembolso == 'PRODUTO'">
            <b-row class="mt-3">
              <b-col class="text-right col-md-12">
                <b-button size="sm" variant="success" @click="addFaturar = !addFaturar">
                  {{ addFaturar ? "Remover Produtos" : "Adicionar produtos" }}
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="ocorrencia.id && addFaturar && tipoMsg == 'SOLUCIONAR'" align-v="end">
              <b-col class="col-md-9">
                <label for="">Produto</label>
                <v-select class="select-produtos" placeholder="Código do Produto" v-model="produto"
                  :options="listProdutosReembolso" @search="getProdutosReembolso"></v-select>
              </b-col>
              <b-col class="col-md-2">
                <label for="">Quantidade</label>
                <b-form-input min="0" max="1000" type="number" size="sm" v-model="qtdProduto"
                  :disabled="!produto || !produto.disponivel" @keyup.enter="addProduto('faturar')"></b-form-input>
              </b-col>
              <b-col class="col-md-1">
                <b-button size="sm" variant="primary" title="Adicionar Produto" @click="addProduto('faturar')"
                  :disabled="!produto || !produto.disponivel">
                  <i class="fas fa-plus"></i>
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="produto" class="ml-3">
                <small class="text-danger">{{ produto.preco }} {{ qtdProduto ? ' x ' + qtdProduto + ' = ' +
                  parseFloat(produto.preco * qtdProduto).toFixed(2).toString().replace('.', ',') : "" }}</small>
              </b-col>
            </b-row>
            <b-row class="mt-3" v-if="aFaturar.length > 0">
              <b-table :items="aFaturar" :fields="colunas" class="mt-2" hover hide-header
                v-if="ocorrencia.id && addFaturar && tipoMsg == 'SOLUCIONAR'">
                <template #cell(actions)="row">
                  <b-button size="sm" variant="danger" @click="removeProduto(row.item, 'faturar')"
                    title="Remover Produto"><i class="fas fa-trash"></i></b-button>
                </template>
                <template #cell(label)="row">
                  <small>
                    {{ row.item.codigo + ' - ' + row.item.nome }}
                  </small>
                </template>
              </b-table>
            </b-row>
            <b-row>
              <b-col cols="12" class="text-right text-danger">
                <small> Total: {{ getTotalReembolso }} </small>
              </b-col>
            </b-row>
          </div>

          <b-row class="mt-3 mb-3">
            <b-col>
              <b-form-textarea id="textarea-rows" no-resize :placeholder="!ocorrencia.id
                ? 'Por favor, descreva a ocorrência com o máximo de detalhes possíveis!'
                : 'Mensagem'
                " rows="10" v-model="mensagem" :disabled="loading">
              </b-form-textarea>
            </b-col>
          </b-row>

          <b-row align-h="center">
            <b-col class="col-md-4 text-center">
              <label for="">Anexos</label>
              <b-form-file size="sm" accept=".jpg, .jpeg, .png, .gif, .pdf" browse-text="Adicionar" v-model="anexos"
                placeholder=".jpg, .jpeg, .png, .gif, .pdf" drop-placeholder="Solte o arquivo aqui..." multiple />
            </b-col>
          </b-row>
        </b-form-group>
        <b-row class="mt-3" align-h="end">
          <b-col class="text-right">
            <b-button v-if="ocorrencia.tipo || status == 'NOVO'" :disabled="loading" size="sm" variant="success"
              @click="salvar()">
              <b-spinner v-if="loading" small variant="primary" label="Spinning"></b-spinner>
              <i v-else class="fas fa-save"></i>
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </b-overlay>
    </b-card>

    <b-modal v-model="modalProdutos" size="xl" title="Produtos do Pedido">
      <b-card>
        <b-row>
          <b-col>
            <label for="">Produto</label>
            <b-form-input id="filter-input" v-model="filterModal" type="search" placeholder="Código"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-table striped hover :items="produtosPedido" :fields="fieldsProdutos" @filtered="onFiltered" small
              stacked="md" :filter="filterModal" :filter-included-fields="filterOn">
              <template #cell(nome)="row">
                <small>
                  {{ row.item.codigo + ' - ' + row.item.nome }}
                </small>
              </template>
              <template #cell(actions)="row">
                <span v-if="row.item.ocorrencia" class="text-center">
                  <small><b>Ocorrência</b> <br> <a :href="'/ocorrencia/' + row.item.ocorrencia" target="__blank"> {{
                    row.item.ocorrencia }} </a></small>
                </span>
                <b-button v-else :variant="row.item.incluir ? 'danger' : 'success'" size="sm"
                  @click="row.item.incluir = !row.item.incluir">
                  {{ row.item.incluir ? 'Remover' : 'Incluir' }}
                </b-button>
              </template>
              <template #cell(quantidade)="row">
                <b-form-input v-if="!row.item.ocorrencia" size="sm" v-model="row.item.quantidade"
                  @change="row.item.quantidade > row.item.qtdOriginal || row.item.quantidade <= 0 ? row.item.quantidade = row.item.qtdOriginal : row.item.quantidade" />
                <small style="color: red">Qtd. Pedido: {{ row.item.qtdOriginal }}</small>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card>
      <template #modal-footer>
        <b-button variant="primary" size="sm" @click="modalProdutos = false">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: "Mensagens",
  props: {
    ocorrenciaProps: {
      type: Object,
      default: {
        produtos: [],
      },
    },
    tipo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      filterOn: [],
      filterModal: null,
      modalProdutos: false,
      notify: [],
      listProdutosR: [],
      optionsLote: null,
      reembolso: "",
      optionsEnviarPara: ['DISTRIBUIDOR', 'REVENDEDORA'],
      classeDistribuidor: "",
      optionsDestinatario: [
        "operacao.plus@infinity.log.br",
        "sac@abelharainha.com",
        "devolucao@infinity.log.br",
        "supervisor.expedicao@infinity.log.br",
        "gerente.logistica@infinity.log.br",
        "supervisor.cdmanaus@infinity.log.br",
        "gerente.logistica@infinity.log.br",
        "supervisor.cdimperatriz@infinity.log.br",
        "gerente.logistica@infinity.log.br",
        { text: "Outro", value: "" },
      ],
      email: {
        destinatario: "",
        mensagem: "",
        selecionado: "",
        anexo: false,
        copiar: "",
      },
      modalEmail: false,
      fieldsProdutos: [
        { key: "actions", label: "", class: 'text-center' },
        { key: "nome", label: "Produto" },
        { key: "quantidade", label: "Quantidade" },
      ],
      colunas: [
        {
          key: "actions",
          label: "",
        },
        {
          key: "label",
          label: "Produto",
          formatter: (value, i, item) => {
            return item.codigo + ' - ' + item.nome
          }
        },
        {
          key: "quantidade",
          label: "Quantidade",
        },
        {
          key: "lote_produto_avaria",
          label: "Lote Avaria",
        },
      ],
      loadingMail: false,
      qtdProduto: 0,
      produto: null,
      listProdutos: [],
      listProdutosReembolso: [],
      produtosPedido: [],
      mensagem: "",
      tipoMsg: "",
      tipoOcorrencia: null,
      status: "",
      anexos: [],
      lote: "",
      revendedora: "",
      revendedoras: [],
      optionsMsg: [],
      aFaturar: [],
      tipoReembolso: null,
      enviarPara: 'DISTRIBUIDOR',
      reembolsoOptions: [
        { text: "", value: "" },
        { text: "APROVADO", value: "APROVADO" },
        { text: "REPROVADO", value: "REPROVADO" }
      ],
      optionsOc: [
        { value: null, text: "Selecione o tipo de ocorrência" },
      ],
      loading: false,
      perfil: "",
      ocorrencia: this.ocorrenciaProps,
      addFaturar: false,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    tipoReembolso(newValue) {
      if (newValue !== 'PRODUTO') {
        this.aFaturar = []
      }
    },
    addFaturar(newValue) {
      if (!newValue) {
        this.aFaturar = []
      }
    },
    tipoOcorrencia(newValue) {
      if (newValue) {
        this.revendedora = "";
        this.produtosPedido = []
        this.lote = ""
      }
    },
    qtdProduto(newValue) {
      if (this.produto && parseInt(this.produto.quantidade) < parseInt(newValue)) {
        this.qtdProduto = 0
      }
    },
    revendedora(newValue) {
      if (newValue) {
        this.produtosPedido = []
        this.getProdutos()
      }
    },
    lote(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.revendedoras = [];
        this.revendedora = "";
        this.produtosPedido = []
        if (this.classeDistribuidor === 'G') {
          this.getRevendedoras();
        } else {
          this.getProdutos();
        }
      }
    },
    addFaturar(newValue) {
      if (newValue) {
        this.aFaturar = [];
      }
    },
    "email.selecionado"(newValue) {
      this.email.destinatario = newValue;
    },
  },

  computed: {
    getTotalReembolso() {
      if (this.aFaturar && this.aFaturar.length > 0) {
        let total = this.aFaturar.reduce((acc, el) => {
          return acc += (parseFloat(el.preco) * parseInt(el.quantidade))
        }, 0)
        return parseFloat(total).toFixed(2).toString().replace('.', ',');
      } else {
        return '0,00'
      }
    },
    valMax() {
      let total = 0
      this.aFaturar.forEach((el) => {
        total += parseFloat(el.preco) * parseInt(el.quantidade)
      })

      total += (parseFloat(this.produto.preco) * parseInt(this.qtdProduto))
      if (total <= parseFloat(this.ocorrencia.valor_max)) {
        return true
      }
      return false
    },
    getProdutosIncluidos() {
      const produtos = this.produtosPedido.filter((el) => el.incluir === true)
      return produtos
    },
    loteProdutoAvariaResumo() {
      if (!this.getProdutosIncluidos || this.getProdutosIncluidos.length === 0) {
        return "";
      }
      return this.getProdutosIncluidos
        .filter((el) => el.lote_produto_avaria)
        .map((el) => `${el.codigo}:${el.lote_produto_avaria}`)
        .join(",");
    },
    showAprovaReembolso() {
      if (this.ocorrencia.id &&
        this.ocorrencia.status != 'FECHADO' &&
        this.ocorrencia.status != 'SOLUCIONADO' &&
        this.ocorrencia.status != 'REABRIR' && (
          this.perfil == 'analista_qualidade' ||
          this.perfil == 'analista_qualidade_logistica' ||
          this.perfil == 'analista_expedicao' ||
          this.perfil == 'analista_transporte' ||
          this.perfil == 'supervisor_transporte' ||
          this.perfil == 'gestor_logistica' ||
          this.perfil == 'supervisor_expedicao'
        )) {
        return true;
      }
      return false
    },
    ocorrenciaReturn() {
      return this.ocorrencia.mensagens
    },
    optionsReembolso() {
      let data = [];
      let lastMsg = this.ocorrencia.mensagens[this.ocorrencia.mensagens.length - 1];
      let lastPerfil = lastMsg.user.roles[0].name;
      if (this.perfil == "coord-comercial" || this.perfil == "coord_comercial") {
        data = [
          {
            value: null,
            text: "Sem Reebolso",
          },
          {
            value: "CREDITO",
            text: "Credito",
          },
          {
            value: "PRODUTO",
            text: "Outros Produtos",
          },
          {
            value: "PRODUTO-RECLAMADO",
            text: "Todos Produtos Reclamados",
          },
        ];
      } else if (this.ocorrencia.reembolso_aprovado && (this.perfil == "comercial" || this.perfil == 'sac') && (
        lastPerfil == 'analista_qualidade' ||
        lastPerfil == 'analista_qualidade_logistica' ||
        lastPerfil == 'analista_expedicao' ||
        lastPerfil == 'analista_transporte' ||
        lastPerfil == 'supervisor_transporte' ||
        lastPerfil == 'gestor_logistica' ||
        lastPerfil == 'supervisor_expedicao'
      )) {
        data = [
          {
            value: null,
            text: "Sem Reebolso",
          },
          {
            value: "PRODUTO",
            text: "Outos Produtos",
          },
          {
            value: "PRODUTO-RECLAMADO",
            text: "Todos Produtos Reclamados",
          },
        ];
      } else {
        data = [
          {
            value: null,
            text: "Sem Reebolso",
          },
        ]
      }

      return data;
    },
    viewCardMensagem() {
      let view = false;
      if (this.ocorrencia && this.ocorrencia.id && this.ocorrencia.status == 'CANCELADA') {
        view = false;
      } else if (
        (!this.ocorrencia.id ||
          (!this.ocorrencia.departamento_atual &&
            (this.perfil == "adm" || this.perfil == "comercial" || this.perfil == "sac")) ||
          ((this.perfil == "supervisor_transporte" ||
            this.perfil == "analista_transporte" ||
            this.perfil == "gestor_logistica") &&
            this.ocorrencia.departamento_atual == "TRANSPORTE") ||
          ((this.perfil == "gestor_qualidade" ||
            this.perfil == "analista_qualidade") &&
            this.ocorrencia.departamento_atual == "QUALIDADE") ||
          ((this.perfil == "gestor_qualidade_logistica" || //nem tem
            this.perfil == "analista_qualidade_logistica") &&
            this.ocorrencia.departamento_atual == "QUALIDADE_LOGISTICA") ||             
          ((this.perfil == "supervisor_expedicao" ||
            this.perfil == "analista_expedicao" ||
            this.perfil == "gestor_logistica") &&
            this.ocorrencia.departamento_atual == "EXPEDICAO") ||
          ((this.perfil == "comercial" || this.perfil == "coord_comercial" || this.perfil == "sac") &&
            this.ocorrencia.departamento_atual == "COMERCIAL")) &&
        this.ocorrencia.status !== "SOLUCIONADO"
      ) {
        view = true;
      } else if (this.perfil == 'distribuidor' && (this.ocorrencia.status == 'SOLUCIONADO' || this.ocorrencia.status == 'FECHADO')) {
        return view
      } else if ((this.perfil == 'distribuidor') && this.ocorrencia.departamento_atual == 'DISTRIBUIDOR') {
        view = true;
      }
      return view;
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getProdutosInListProdutos(key) {
      if (key.length <= 3) {
        return;
      }
      this.listProdutosReembolso = [];
      let produtos = this.produtosPedido.filter((el) => {

      })
      this.listProdutosR = produtos
    },
    optionsMsgs() {
      if (!this.ocorrencia.id && this.perfil == "distribuidor") {
        this.optionsMsg = [
          {
            value: "NOVO",
            text: "Novo",
          },
        ];
        this.tipoMsg = "NOVO";
      } else if (this.perfil == "distribuidor") {
        this.optionsMsg = [
          {
            value: "RESPONDER",
            text: "Responder",
          },
        ];
        this.tipoMsg = "RESPONDER";
      } else if (
        ["adm", "comercial", "sac", "coord-comercial", "coord_comercial"].includes(this.perfil) &&
        this.ocorrencia.id
      ) {
        this.optionsMsg = [
          {
            text: "RESPONDER PARA O DISTRIBUIDOR",
            value: "RESPONDER",
          },
          {
            text: "PENDENCIAR",
            value: "PENDENCIAR",
          },
          {
            text: "SOLUCIONAR",
            value: "SOLUCIONAR",
          },
          {
            text: "ENCAMINHAR PARA QUALIDADE LOGISTICA",
            value: "QUALIDADE_LOGISTICA",
          },
          {
            text: "ENCAMINHAR PARA QUALIDADE",
            value: "QUALIDADE",
          },
          {
            text: "ENCAMINHAR PARA TRANSPORTE",
            value: "TRANSPORTE",
          },
          {
            text: "ENCAMINHAR PARA EXPEDIÇÃO",
            value: "EXPEDICAO",
          },
        ];
      } else if (
        [
          "analista_qualidade",
          "gestor_qualidade",
          "supervisor_expedicao", 
          "gestor_logistica",
          "supervisor_transporte",
          "analista_expedicao",
          "analista_transporte",
          "analista_qualidade_logistica",
        ].includes(this.perfil)
      ) {
        this.optionsMsg = [
          {
            text: "ENCAMINHAR PARA COMERCIAL",
            value: "COMERCIAL",
          },
          {
            text: "ENCAMINHAR PARA QUALIDADE LOGISTICA",
            value: "QUALIDADE_LOGISTICA",
          },
          {
            text: "ENCAMINHAR PARA QUALIDADE",
            value: "QUALIDADE",
          },
          {
            text: "ENCAMINHAR PARA EXPEDIÇÃO",
            value: "EXPEDICAO",
          },
        ];
      }
    },
    formatarData(data) {
      return moment(data).format("DD/MM/YYYY HH:mm:ss");
    },
    init() {
      this.tipoMsg = "";
      this.mensagem = "";
      if (this.ocorrencia && this.ocorrencia.id) {
        // this.perfil = this.ocorrencia.perfil;
        this.status = this.ocorrencia.status;
        this.tipoOcorrencia = this.ocorrencia.tipo;
        this.notificacoes = this.ocorrencia.notificacoes;
      } else if (document.getElementById("ocorrencia").value) {
        this.ocorrencia = JSON.parse(
          document.getElementById("ocorrencia").value
        );
        this.status = this.ocorrencia.status;
        this.tipoOcorrencia = this.ocorrencia.tipo;
      } else {
        this.status = "NOVO";
        this.tipoMsg = "NOVO";
      }
      this.perfil = this.ocorrencia.perfil ? this.ocorrencia.perfil : document.getElementById("perfil").value
      const vm = this;
      if (this.perfil == 'distribuidor') {
        axios.get('/ocorrencia/get/init').then((response) => {
          response.data.tipos.forEach((el) => {
            vm.optionsOc.push(el);
          })
          vm.optionsLote = response.data.lotes.map((el) => {
            return el.codigo
          })
          vm.classeDistribuidor = response.data.classe ? response.data.classe : "";
          if (vm.classeDistribuidor == 'G') {
            vm.enviarPara = 'REVENDEDORA'
          }
        }).catch((error) => {
          console.log(error)
        })
      }
      this.optionsMsgs();
    },
    produtoClear() {
      this.ocorrencia.produtos = [];
    },
    removeProduto(item, faturar = null) {
      if (faturar === "faturar") {
        this.aFaturar = this.aFaturar.filter((el) => el.value !== item.value);
      } else {
        this.ocorrencia.produtos = this.ocorrencia.produtos.filter(
          (el) => el.value !== item.value
        );
      }
    },
    addProduto(faturar = null) {
      const vm = this;
      if (!vm.produto) {
        return vm.$swal({
          title: "Atenção",
          text: "Selecione o produto",
          icon: "error",
        });
      }
      if (vm.qtdProduto <= 0) {
        return vm.$swal({
          title: "Atenção",
          text: "Quantidade inválida",
          icon: "error",
        });
      }

      if (faturar && !this.valMax) {
        return vm.$swal({
          title: "Atenção",
          text: "O valor máximo para reembolso foi excedido",
          icon: "error",
        });

      }
      var hasItem = false;
      if (faturar === "faturar") {
        vm.aFaturar = vm.aFaturar.map((el) => {
          if (el.value == vm.produto.value) {
            hasItem = true;
            el.quantidade = String(
              parseInt(el.quantidade) + parseInt(vm.qtdProduto)
            );
          }
          return el;
        });
      } else {
        vm.ocorrencia.produtos = vm.ocorrencia.produtos.map((el) => {
          if (el.value == vm.produto.value) {
            hasItem = true;
            el.quantidade = String(
              parseInt(el.quantidade) + parseInt(vm.qtdProduto)
            );
          }
          return el;
        });
      }
      if (!hasItem) {
        vm.produto.quantidade = vm.qtdProduto;
        if (faturar === "faturar") {
          vm.aFaturar.push(vm.produto);
        } else {
          vm.ocorrencia.produtos.push(vm.produto);
        }
      }
      vm.produto = null;
      vm.qtdProduto = 0;
    },
    getProdutos() {
      const vm = this;
      let rev = null
      if (this.classeDistribuidor === 'G') {
        rev = this.revendedoras.find((el) => el.value == this.revendedora)
      }
      const params = {
        pedido_id: rev ? rev.pedido_id : null,
        revendedora: this.revendedora.id,
        lote: this.lote
      }
      this.listProdutos = [];
      vm.produtosPedido = []
      vm.loading = true
      axios
        .get("/ocorrencia/get/produtos", { params: params })
        .then((response) => {
          vm.produtosPedido = response.data.map((el) => {
            el.incluir = false;
            el.qtdOriginal = el.quantidade;
            el.lote_produto_avaria = "";
            return el
          })
        })
        .catch((error) => {
          console.log(error);
        }).finally(() => {
          vm.loading = false
        });
    },
    getProdutosReembolso(key) {
      const vm = this;
      if (key.length <= 3) {
        return;
      }
      this.listProdutosReembolso = [];
      axios
        .get("/produtos-all", { params: { codigo: key, reembolso: true } })
        .then((response) => {
          let obj = response.data;
          obj.forEach((v) => {
            vm.listProdutosReembolso.push({
              value: v.id,
              label: v.codigo + " - " + v.nome,
              disponivel: v.pivot.disponivel,
              preco: v.pivot.preco,
              nome: v.nome,
              codigo: v.codigo
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removerImg(img) {
      if (img === "etiqueta") this.anexos.etiqueta = null;
      if (img === "caixa") this.anexos.caixa = null;
      if (img === "produto") this.anexos.produto = null;
      if (img === "resposta") this.anexos.resposta = [];
    },
    getRevendedoras() {
      const vm = this;
      if (vm.lote) {
        vm.loading = true
        axios
          .get("/ocorrencia/get/revendedoras/" + vm.lote)
          .then((response) => {
            if (response.data) {
              vm.revendedoras = response.data.map((el) => {
                return {
                  value: el.id,
                  text: el.nome,
                  pedido_id: el.pedido_id
                };
              });
            }
          })
          .catch((erro) => {
            console.log(erro);
          }).finally(() => {
            vm.loading = false
          });
      }
    },
    reabrirOc() {
      this.tipoMsg = "REABRIR";
      this.mensagem = 'Reabrindo Ocorrencia para Reavaliação'
      this.ocorrencia.status = "REABRIR";
      this.salvar()
    },
    cancelar(){
      const vm = this;
      vm.$swal({
          icon: 'warning',
          title: "Atenção",
          html: 'Desaja realmente cancelar a ocorrência ' + vm.ocorrencia.id + ' ?',
          footer: 'Esta ação não poderá ser revertida!',
          showDenyButton: true,
          confirmButtonText: "Sim, Cancelar",
          denyButtonText: "Não"
        }).then((result) => {
          if (result.isConfirmed) {
            vm.tipoMsg = "CANCELAR";
            vm.mensagem = 'Ocorrência Cancelada'
            vm.ocorrencia.status = "CANCELADA";
            vm.salvar()
          }
        });
    },
    salvar() {
      const vm = this;
      let val = true;
      vm.anexos.forEach((el) => {
        if (el.size > 2000000) {
          val = false;
        }
      });
      if (!val) {
        return vm.$swal({
          title: "Atenção",
          text: "Um anexo ultrapassou o tamanho máximo de 2Mb",
          icon: "error",
        });
      }
      if (!this.mensagem || this.mensagem.length <= 10) {
        return vm.$swal({
          title: "Atenção",
          text: "A mensagem deve ter no mínimo 10 caracteres",
          icon: "error",
        });
      }

      if (
        this.ocorrencia.id &&
        !this.reembolso &&
        this.ocorrencia.status != 'FECHADO' &&
        this.ocorrencia.status != 'SOLUCIONADO' &&
        this.ocorrencia.status != 'REABRIR' &&
        (this.perfil == 'analista_qualidade' ||
          this.perfil == 'analista_qualidade_logistica' ||
          this.perfil == 'analista_expedicao' ||
          this.perfil == 'analista_transporte' ||
          this.perfil == 'supervisor_transporte' ||
          this.perfil == 'gestor_logistica' ||
          this.perfil == 'supervisor_expedicao')
      ) {
        return vm.$swal({
          title: "Atenção",
          text: "Informe se deseja aprovar o reembolso",
          icon: "error",
        });
      }

      if (!this.tipoMsg) {
        return vm.$swal({
          title: "Atenção",
          text: "Selecione o tipo da ocorrência",
          icon: "error",
        });
      }
      if (
        (this.tipoOcorrencia < 4 || this.tipoOcorrencia == 6) &&
        !this.ocorrencia.id &&
        (!this.getProdutosIncluidos || this.getProdutosIncluidos <= 0)
      ) {
        return vm.$swal({
          title: "Atenção",
          text: "Adicione pelo menos um produto!",
          icon: "error",
        });
      } else {
        this.ocorrencia.produtos = this.getProdutosIncluidos;

        const produtosSemLoteAvaria = this.getProdutosIncluidos.filter((el) => !el.lote_produto_avaria || String(el.lote_produto_avaria).trim() === "");
        if (produtosSemLoteAvaria.length > 0) {
          const codigos = produtosSemLoteAvaria.map((el) => el.codigo).join(", ");
          return vm.$swal({
            title: "Atenção",
            text: `Informe o lote de avaria para os produtos: ${codigos}`,
            icon: "error",
          });
        }
      }

      if (this.classeDistribuidor === 'G' && !this.ocorrencia.id && !this.revendedora) {
        return vm.$swal({
          title: "Atenção",
          text: "Selecione a Revendedora do Pedido!",
          icon: "error",
        });
      }

      if (vm.anexos.length > 3) {
        return vm.$swal({
          title: "Atenção",
          text: "São permitidos no máximo 3 anexos!",
          icon: "error",
        });
      }
      if (vm.tipoMsg == 'SOLUCIONAR' && vm.tipoReembolso == 'PRODUTO' && vm.aFaturar.length <= 0) {
        return vm.$swal({
          title: "Atenção",
          text: "Adicione os produtos para reembolso",
          icon: "error",
        });
      }

      if (vm.tipoMsg == 'SOLUCIONAR') {
        let msg = '';
        if (!vm.tipoReembolso) {
          msg = 'Deseja solucionar a ocorrência ' + vm.ocorrencia.id + ' <br> <b> sem reembolso </b>?'
        } else if (vm.tipoReembolso == 'PRODUTO') {
          msg = 'Deseja solucionar a ocorrência ' + vm.ocorrencia.id + ' e realizar o reembolso com os produtos informados?'
        } else if (vm.tipoReembolso == 'CREDITO') {
          msg = 'Deseja solucionar a ocorrência ' + vm.ocorrencia.id + ' e realizar o reembolso em créditos?'
        } else if (vm.tipoReembolso == 'PRODUTO-RECLAMADO') {
          msg = 'Deseja solucionar a ocorrência ' + vm.ocorrencia.id + ' e realizar o reembolso de todos os produtos reclamados?'
        }
        vm.$swal({
          icon: 'warning',
          title: "Atenção",
          html: msg,
          footer: 'Esta ação não poderá ser revertida!',
          showDenyButton: true,
          confirmButtonText: "Sim, Solucionar",
          denyButtonText: `Cancelar`
        }).then((result) => {
          if (result.isConfirmed) {
            vm.confirmaSave()
          }
        });
      } else {
        vm.confirmaSave()
      }

    },
    confirmaSave() {
      const vm = this;
      let form = new FormData();
      form.append("status", vm.status);
      form.append("mensagem", vm.mensagem);
      form.append("tipoMsg", vm.tipoMsg);
      form.append("tipo", vm.tipoOcorrencia);
      form.append("reembolso", vm.reembolso);
      if (this.perfil == 'distribuidor' && this.status == 'NOVO' && this.classeDistribuidor === 'G') {
        const rev = this.revendedoras.find((el) => el.value == this.revendedora)
        form.append("pedido_id", rev.pedido_id);
      }
      if (vm.classeDistribuidor === 'G') {
        form.append("enviarPara", vm.enviarPara);
      } else {
        form.append("enviarPara", 'DISTRIBUIDOR');
      }
      if (vm.ocorrencia.id) {
        form.append("id", vm.ocorrencia.id);
        if (vm.tipoMsg == "SOLUCIONAR" && vm.aFaturar) {
          form.append("tipoReembolso", vm.tipoReembolso);
          let produtos = "";
          if (this.aFaturar) {
            this.aFaturar.forEach((el) => {
              produtos += el.value + "-" + el.quantidade + "-" + el.item_pedido_id + " ";
            });
          }
          form.append("produtosFaturar", produtos);
        }
      } else {
        let produtos = "";
        if (this.ocorrencia.produtos) {
          this.ocorrencia.produtos.forEach((el) => {
            produtos += el.id + "-" + el.quantidade;
            if (el.item_pedido_id) {
              produtos += "-" + el.item_pedido_id
            } else {
              produtos += "-"
            }
            produtos += "-" + (el.lote_produto_avaria ? String(el.lote_produto_avaria).trim() : "") + " "
          });
        }
        form.append("produtos", produtos);
        form.append("revendedora", vm.revendedora);
        form.append("lote", vm.lote);
      }

      if (vm.anexos.length > 0) {
        vm.anexos.forEach((el, index) => {
          form.append("anexo_" + index, el);
        });
      }
      vm.loading = true;
      axios
        .post("/ocorrencia", form)
        .then((response) => {
          vm.$swal({
            title: "Sucesso!",
            text: "Ocorrência salva com sucesso.",
            icon: "success",
          }).then(() => {
            if (response.data.id) {
              window.location.href = "/ocorrencia/" + response.data.id;
            } else {
              vm.removerImg("resposta");
              vm.tipoMsg = "";
              vm.mensagem = "";
              vm.ocorrencia = {};
              vm.$emit("loadOcorrencias");
              vm.$emit("close");
            }
          });
        })
        .catch((erro) => {
          let erros = null;
          if (erro.response.data.message) {
            erros = JSON.parse(erro.response.data.message);
            erros = erros.mensagem;
          } else if (erro.response.data.errors) {
            erros = erro.response.data.errors;
            erros = erros;
          }
          vm.$swal({
            title: "Erro ao salvar ocorrência!",
            text: erros,
            icon: "error",
          });
        })
        .finally(() => {
          vm.loading = false;
        });
    },
  },
};
</script>

<style>
.EXPEDICAO {
  background-color: #ffe0e1;
}

.TRANSPORTE {
  background-color: #ffe0e1;
}

.QUALIDADE {
  background-color: #ffe0e1;
}

.QUALIDADE_LOGISTICA {
  background-color: #ffe0e1;
}

.NOVO {
  background-color: rgb(222, 255, 221);
}

.RESPONDER {
  background-color: rgb(214, 214, 214);
}

.PENDENCIAR {
  background-color: rgb(255, 254, 197);
}

.SOLUCIONAR {
  background-color: rgb(207, 232, 255);
}

.REABRIR {
  background-color: rgb(255, 210, 210);
}

.select-produtos {
  background-color: white;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ocorrencia/componente/Mensagens.vue